import "core-js/modules/es6.object.create";
export default function (child, parent) {
  var proto = child.prototype = Object.create(parent.prototype);
  proto.constructor = child;
  return proto;
}